import { Link } from "react-router-dom";
import { Menu, Image, Icon } from "semantic-ui-react";
import styled from "styled-components";
import GiraffeLoaderImagePreload from "./GiraffeLoaderImagePreload";

const LinkNoHover = styled(Link)`
  &:hover {
    background: none !important;
  }
`;

const ImageDiv = styled.div`
  background-image: url(/assets/ha-headerlogo.svg);
  width: 124px;
  height: 50px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
`;

const TopNav = ({ onHamburgerMenuClick, homeRoute, children, inverted }) => {
  const navigateToHomeRoute = () => {
    if (homeRoute === "/") {
      window.location.href = homeRoute;
    }
  };

  return (
    <Menu inverted={inverted} borderless attached="top" className="top-nav">
      {onHamburgerMenuClick && (
        <Menu.Item onClick={onHamburgerMenuClick}>
          <Icon name="sidebar" size="large" className="hamburger-menu" />
        </Menu.Item>
      )}
      <Menu.Item
        as={LinkNoHover}
        header
        to={homeRoute}
        onClick={navigateToHomeRoute}
        style={{ padding: "0.5em 1em" }}
      >
        {inverted ? (
          <Image
            src="/assets/ha-header-logo-light.png"
            style={{ marginRight: "1.5em", width: "110px", height: "auto" }}
          />
        ) : (
          <ImageDiv inverted={inverted} />
        )}
        <GiraffeLoaderImagePreload />
      </Menu.Item>
      {children}
    </Menu>
  );
};

export default TopNav;
